var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3444 8.6347C18.9194 9.64513 20.1878 10.8697 20.9699 11.7109C21.0813 11.8361 21.1429 11.9979 21.1429 12.1656C21.1429 12.3332 21.0813 12.495 20.9699 12.6202C20.1878 13.4614 18.9194 14.686 17.3444 15.6964C15.7615 16.7119 13.9269 17.474 12 17.474C10.0731 17.474 8.23851 16.7119 6.65563 15.6964C5.0806 14.686 3.81223 13.4614 3.03007 12.6203C2.91872 12.495 2.85714 12.3333 2.85714 12.1656C2.85714 11.9979 2.91872 11.8361 3.03007 11.7109C3.81223 10.8697 5.0806 9.64513 6.65563 8.6347C8.23851 7.61923 10.0731 6.85714 12 6.85714C13.9269 6.85714 15.7615 7.61923 17.3444 8.6347Z",
    stroke: "#242E3D",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 15.2486C13.7033 15.2486 15.0835 13.8684 15.0835 12.1658C15.0835 10.4632 13.7033 9.08301 12.0008 9.08301C10.2982 9.08301 8.91797 10.4632 8.91797 12.1658C8.91797 13.8684 10.2982 15.2486 12.0008 15.2486Z",
    stroke: "#242E3D",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordShow);
export default __webpack_public_path__ + "static/media/password-show.53e54c03f5d7d1aa3cc73e1a83ac7f37.svg";
export { ForwardRef as ReactComponent };